const subheadingsData = {
  1: [
    {
      title: "Sobre Mí",
      content: (
        <>
          <p>
Hola, soy Nico, desarrollador web fullstack. <br></br>Creo aplicaciones completas que transforman ideas en experiencias digitales intuitivas y funcionales, combinando creatividad y buenas prácticas para resolver problemas reales.          </p>
        </>
      ),
    },
  ],
  2: [
    {
      title: "2025 - Máster Prototipado UX/UI y Marketing Digital",
      content: (
        <>
          <p>
            Próximamente comenzaré el Máster en Prototipado UX/UI y Máster Digital en CEI, donde profundizaré en diseño centrado en el usuario y soluciones digitales innovadoras.
          </p>
        </>
      ),
    },
    {
      title: "2025 - Desarrollo de Aplicaciones Web (DAW)",
      content: (
        <>
          <p>
            He completado el ciclo superior de Desarrollo de Aplicaciones Web (DAW) en el Instituto Nebrija, adquiriendo las competencias necesarias para crear aplicaciones web completas y funcionales.
          </p>
        </>
      ),
    },
  ],
  3: [
    {
      title: "2025 - Freelancer",
      content: (
        <>
          <p>
            Como freelancer, he desarrollado múltiples proyectos web, creando sitios y aplicaciones funcionales, intuitivos y adaptados a las necesidades de cada cliente.
          </p>
        </>
      ),
    },
    {
      title: "2025 - Consultor IT",
      content: (
        <>
          <p>
            Realicé prácticas en Deloitte para Generali en el área de Fine Crime, donde trabajé con Actimize para analizar y gestionar riesgos, desarrollando habilidades en procesos de detección y prevención de fraudes.
          </p>
        </>
      ),
    },
    
  ],
};

export default subheadingsData;
